/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetLedgerPositionsSelfOptions,
  GetLedgerPositionsSelfResponses,
} from '../types/GetLedgerPositionsSelf'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get your own positions
 * {@link /v1/ledger/positions/self}
 */
export function getLedgerPositionsSelf<ThrowOnError extends boolean = true>(
  options: Options<GetLedgerPositionsSelfOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<GetLedgerPositionsSelfResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/ledger/positions/self',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetLedgerPositionsSelfResponses, ThrowOnError>>,
  )
}
